import { Injectable } from '@angular/core';
import { LogEntry } from './models/log-entry';
import { LogLevel } from './models/log-level.enum';
import { LogWriter } from './writers/log-writer';
import { Settings } from '../settings';

@Injectable()
export class LogService {
    public level = LogLevel.Error;
    public writers: LogWriter[];

    constructor(settings: Settings) {
        this.level = settings.logConfigService.getLogLevel();
        this.writers = settings.logConfigService.getLogWriters();
    }

    public log(message: string, ...params: any[]): void {
        this.writeLog(message, LogLevel.All, params);
    }

    public debug(message: string, ...params: any[]): void {
        this.writeLog(message, LogLevel.Debug, params);
    }

    public info(message: string, ...params: any[]): void {
        this.writeLog(message, LogLevel.Info, params);
    }

    public warn(message: string, ...params: any[]): void {
        this.writeLog(message, LogLevel.Warn, params);
    }

    public error(message: string, ...params: any[]): void {
        this.writeLog(message, LogLevel.Error, params);
    }

    public fatal(message: string, ...params: any[]): void {
        this.writeLog(message, LogLevel.Fatal, params);
    }

    private shouldLog(level: LogLevel): boolean {
        if ((level >= this.level && this.level !== LogLevel.Off)) {
            return true;
        }

        return false;
    }

    private writeLog(message: string, level: LogLevel, params: any[]): void {
        if (this.shouldLog(level)) {
            const logEntry = new LogEntry(message, level, params);

            for (const writer of this.writers) {
                writer.log(logEntry);
            }
        }
    }
}
